import { DropdownSelector } from './Dropdown';

const VOICE_OPTIONS = [
  // OpenAI
  { value: 'openai-alloy', label: 'OpenAI Alloy' },
  { value: 'openai-ash', label: 'OpenAI Ash' },
  { value: 'openai-ballad', label: 'OpenAI Ballad' },
  { value: 'openai-coral', label: 'OpenAI Coral' },
  { value: 'openai-echo', label: 'OpenAI Echo' },
  { value: 'openai-fable', label: 'OpenAI Fable' },
  { value: 'openai-nova', label: 'OpenAI Nova' },
  { value: 'openai-onyx', label: 'OpenAI Onyx' },
  { value: 'openai-sage', label: 'OpenAI Sage' },
  { value: 'openai-shimmer', label: 'OpenAI Shimmer' },
  // Deepgram
  { value: 'deepgram-odysseus', label: 'Deepgram Odysseus' },
  { value: 'deepgram-apollo', label: 'Deepgram Apollo' },
  { value: 'deepgram-athena', label: 'Deepgram Athena' },
  { value: 'deepgram-theia', label: 'Deepgram Theia' },
  // Google Chirp3 HD - Female
  { value: 'google-achernar', label: 'Google Achernar' },
  { value: 'google-aoede', label: 'Google Aoede' },
  { value: 'google-autonoe', label: 'Google Autonoe' },
  { value: 'google-callirrhoe', label: 'Google Callirrhoe' },
  { value: 'google-despina', label: 'Google Despina' },
  { value: 'google-erinome', label: 'Google Erinome' },
  { value: 'google-gacrux', label: 'Google Gacrux' },
  { value: 'google-kore', label: 'Google Kore' },
  { value: 'google-laomedeia', label: 'Google Laomedeia' },
  { value: 'google-leda', label: 'Google Leda' },
  { value: 'google-pulcherrima', label: 'Google Pulcherrima' },
  { value: 'google-sulafat', label: 'Google Sulafat' },
  { value: 'google-vindemiatrix', label: 'Google Vindemiatrix' },
  { value: 'google-zephyr', label: 'Google Zephyr' },
  // Google Chirp3 HD - Male
  { value: 'google-achird', label: 'Google Achird' },
  { value: 'google-algenib', label: 'Google Algenib' },
  { value: 'google-algieba', label: 'Google Algieba' },
  { value: 'google-alnilam', label: 'Google Alnilam' },
  { value: 'google-charon', label: 'Google Charon' },
  { value: 'google-enceladus', label: 'Google Enceladus' },
  { value: 'google-fenrir', label: 'Google Fenrir' },
  { value: 'google-iapetus', label: 'Google Iapetus' },
  { value: 'google-orus', label: 'Google Orus' },
  { value: 'google-puck', label: 'Google Puck' },
  { value: 'google-rasalgethi', label: 'Google Rasalgethi' },
  { value: 'google-sadachbia', label: 'Google Sadachbia' },
  { value: 'google-sadaltager', label: 'Google Sadaltager' },
  { value: 'google-schedar', label: 'Google Schedar' },
  { value: 'google-umbriel', label: 'Google Umbriel' },
  { value: 'google-zubenelgenubi', label: 'Google Zubenelgenubi' },
];

interface VoiceSelectorProps {
  voice: string;
  setVoice: (voice: string) => void;
  disabled?: boolean;
}

const VoiceSelector = ({ voice, setVoice, disabled }: VoiceSelectorProps) => {
  const currentOption = VOICE_OPTIONS.find((o) => o.value === voice);
  const displayLabel = currentOption?.label || voice || 'openai-onyx';

  return (
    <DropdownSelector
      value={voice}
      options={VOICE_OPTIONS}
      onChange={setVoice}
      disabled={disabled}
      renderButton={({ isOpen, toggle }) => (
        <button
          className="pill-button"
          onClick={toggle}
          disabled={disabled}
          style={{
            WebkitTapHighlightColor: 'transparent',
            touchAction: 'manipulation',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Voice: {displayLabel}</span>
          <span style={{ fontSize: '0.75rem' }}>{isOpen ? '▴' : '▾'}</span>
        </button>
      )}
    />
  );
};

export default VoiceSelector;
